import React, {useContext, useState} from 'react';
import './Editable.css';
import 'react-phone-number-input/style.css'
import '../../App/Styles.css'
import {Editable, EditableProps} from "./Editable";
import {EditableContext, useEditable} from "./EditableContext";
import {EmailOrPhoneLocation, space} from "../../provider_api";
import {useProviderProfile} from "../../ProviderProfileProvider";
import {VerifyContactMethodOverlay} from "../VerifyContactMethodOverlay";
import {isProviderEmailVerified} from "../../util/ProviderUtil";
import {isBusinessEmailVerified} from "../../util/BusinessUtil";
import ContactMethodType = space.kenko.proto.ContactMethodType;

type Props<EnclosingType extends object> = EditableProps<EnclosingType, string> & {
  location: EmailOrPhoneLocation,
}

export const EditableVerifiedEmailField = <EnclosingType extends object>(props: Props<EnclosingType>) => {

  const {editing, mode, value, setValue} = useEditable(props);

  const {business, provider} = useProviderProfile();
  
  // If they clicked the verify button!!
  const [isVerifying, setIsVerifying] = useState(false);

  let isVerified = false;
  switch(props.location) {
    case EmailOrPhoneLocation.PROVIDER:
      isVerified = isProviderEmailVerified(provider, value);
      break;
    case EmailOrPhoneLocation.BUSINESS:
      isVerified = isBusinessEmailVerified(business, value);
      break;
  }

  if (editing) {
    return <Editable {...props}>
      <input className={'EditableEditing'}
             type={'email'}
             value={value ?? ''}
             onChange={e => {
               setValue(e.target.value);
             }}/>
    </Editable>

  } else {

    return <Editable {...props}>
      <div className={'EditableNotEditing'}>
        {value} {value && (isVerified ? '(verified)' : <>(not verified) [<a
          style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={() => setIsVerifying(true)}>verify
        now</a>]</>)}
      </div>

      {isVerifying && <VerifyContactMethodOverlay
          type={ContactMethodType.EMAIL}
          location={props.location} value={value}
          onDone={() => setIsVerifying(false)}/>}

    </Editable>
  }
}
